import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Traverse } from '../models/models/pages/traverse';


@Injectable({
    providedIn: 'root'
})
export class TraverseService {
    private baseUrl = `${environment.baseApiUrl}/traverse`;


    constructor(private http: HttpClient) { }

    list(): Observable<Traverse[]> {
        return this.http.get<Traverse[]>(this.baseUrl); 
    }
}
